import PropTypes from 'prop-types';

import Logo from './Logo';

function Footer({ onOpenTerms, t }) {
    return (
        <footer className="footer content-width">
            <Logo />
            <div className="footer-copy">
                <p>{t('thanks')}</p>
                <p>{t('help')} <a href="mailto:help@fastproxy.ink">help@fastproxy.ink</a></p>
                <button type="button" onClick={onOpenTerms}>{t('userAgreement')}</button>
            </div>
        </footer>
    );
}

Footer.propTypes = {
    onOpenTerms: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default Footer;
